// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"aDxB0","link":"__8cZkM"};